import { makeStyles } from '@material-ui/core/styles'

export const NAV_BAR_HEIGHT = 76 + 32 + 16 + 8 // 76px for navbar, 32px for account switcher, 16px for margin, 8px for padding
export const NAV_BAR_WIDTH = 70

export default makeStyles(theme => ({
  app: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100vh',
    flex: '1 1 auto'
  },
  mainFullWidth: {
    marginLeft: NAV_BAR_WIDTH
  },
  content: {
    flex: '1 1 auto',
    overflow: 'auto'
  },
  flexContent: {
    flex: '1 1 auto',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column'
  },
  accountSwitcherWrapper: {
    position: 'relative',
    width: '100%',
    height: '40px'
  },
  convergedMessageLogLink: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
    position: 'absolute',
    right: 0
  }
}))
